import React, { FC, useCallback, useRef } from "react";
import { Icon } from "@material-ui/core";

export interface IAddButton {
  handleAddButton: (qtd: number) => void;
}

const AddButton: FC<IAddButton> = ({ handleAddButton }) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const handlePressStart = useCallback((e?: React.MouseEvent | React.TouchEvent) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    handleAddButton(1);

    timeoutRef.current = setTimeout(() => {
      intervalRef.current = setInterval(() => {
        handleAddButton(5);
      }, 500);
    }, 800);
  }, [handleAddButton]);

  const handlePressEnd = useCallback((e?: React.MouseEvent | React.TouchEvent) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);

  return (
    <Icon
      onMouseDown={e => {
        e.stopPropagation();
        if (e.type === "mousedown" && e.button !== 0) return; // Only left button
        // Só chama para mouse, não para touch
        if (typeof window !== "undefined" && "ontouchstart" in window) return;
        handlePressStart(e);
      }}
      onTouchStart={e => {
        e.stopPropagation();
        handlePressStart(e);
      }}
      onMouseUp={e => {
        e.stopPropagation();
        handlePressEnd(e);
      }}
      onMouseLeave={e => {
        e.stopPropagation();
        handlePressEnd(e);
      }}
      onTouchEnd={e => {
        e.stopPropagation();
        handlePressEnd(e);
      }}
      onTouchCancel={e => {
        e.stopPropagation();
        handlePressEnd(e);
      }}
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      add
    </Icon>
  );
};

export default AddButton;
